import React from "react";
import { Link } from "react-router-dom";
import { useCart } from "../lib/CartContext";
import { useAuth, loginWithGoogle } from "../lib/AuthContext";
import ProductCard from "../components/ProductCard";

export default function Wishlist() {
  const { user } = useAuth();
  const { wishlist } = useCart();

  if (!user) return (
    <main className="pt-40 pb-32 text-center" data-testid="wishlist-page">
      <h1 className="h-display text-5xl text-[#F8F4E6] mb-6">Lista de Dorințe</h1>
      <p className="text-[#A39E8A] mb-8">Conectează-te pentru a-ți salva piesele preferate.</p>
      <button onClick={loginWithGoogle} className="btn-gold">Conectare Google</button>
    </main>
  );

  return (
    <main className="pt-32 pb-20" data-testid="wishlist-page">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
        <header className="mb-12 text-center">
          <p className="label-luxe text-[#D4AF37] mb-3">Selecția Ta</p>
          <h1 className="h-display text-5xl sm:text-6xl text-[#F8F4E6]">Lista de Dorințe</h1>
        </header>
        {wishlist.length === 0 ? (
          <div className="text-center py-20">
            <p className="font-serif text-2xl text-[#A39E8A] mb-6">Nicio piesă salvată</p>
            <Link to="/shop" className="btn-gold">Explorează Colecția</Link>
          </div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
            {wishlist.map((p, i) => <ProductCard key={p.id} product={p} idx={i} />)}
          </div>
        )}
      </div>
    </main>
  );
}
